import { render, staticRenderFns } from "./Homepage.vue?vue&type=template&id=2832a040&scoped=true"
import script from "./Homepage.vue?vue&type=script&lang=js"
export * from "./Homepage.vue?vue&type=script&lang=js"
import style0 from "./Homepage.vue?vue&type=style&index=0&id=2832a040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2832a040",
  null
  
)

export default component.exports